export default class MatchMediaWatcher {
  constructor() {
    this.mql = null;
    this.handler = null;
  }

  callback(cb) {
    cb(this.mql.matches);
  }

  initWatcher(mediaQuery: string) {
    this.mql = window.matchMedia(mediaQuery);
  }

  execute() {
    this.handler();
  }

  static isSupportAddEventListener() {
    return 'addEventListener' in window.matchMedia('');
  }

  static getWatcher() {
    if (MatchMediaWatcher.isSupportAddEventListener()) {
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      return new ModernWayAddHandler();
    }

    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return new DeprecatedWayAddHandler();
  }
}

class ModernWayAddHandler extends MatchMediaWatcher {
  addHandler(mediaQuery: string, cb) {
    this.handler = this.callback.bind(this, cb);
    this.initWatcher(mediaQuery);
    this.mql.addEventListener('change', this.handler);
  }

  removeHandler() {
    this.mql.removeEventListener('change', this.handler);
  }
}

class DeprecatedWayAddHandler extends MatchMediaWatcher {
  addHandler(mediaQuery: string, cb) {
    this.handler = this.callback.bind(this, cb);
    this.initWatcher(mediaQuery);
    this.mql.addListener(this.handler);
  }

  removeHandler() {
    this.mql.removeListener(this.handler);
  }
}
